import { useEffect } from 'react';

const DEFAULT_TITLE = 'Claritas - Secure Catholic Giving Platform';
const DEFAULT_DESCRIPTION =
  'Support your parish through secure, automated giving. Connect your bank account and automatically round up everyday purchases to donate to your Catholic parish community.';

/**
 * Sets the document title and meta description for the current page.
 * Restores defaults when the component unmounts.
 */
export function usePageMeta({ title, description }) {
  useEffect(() => {
    const prevTitle = document.title;
    const metaDesc = document.querySelector('meta[name="description"]');
    const prevDesc = metaDesc ? metaDesc.getAttribute('content') : DEFAULT_DESCRIPTION;
    const metaOgTitle = document.querySelector('meta[property="og:title"]');
    const metaOgDesc = document.querySelector('meta[property="og:description"]');
    const metaTwitterTitle = document.querySelector('meta[name="twitter:title"]');
    const metaTwitterDesc = document.querySelector('meta[name="twitter:description"]');

    if (title) {
      document.title = title;
      if (metaOgTitle) metaOgTitle.setAttribute('content', title);
      if (metaTwitterTitle) metaTwitterTitle.setAttribute('content', title);
    }

    if (description) {
      if (metaDesc) metaDesc.setAttribute('content', description);
      if (metaOgDesc) metaOgDesc.setAttribute('content', description);
      if (metaTwitterDesc) metaTwitterDesc.setAttribute('content', description);
    }

    return () => {
      document.title = prevTitle;
      if (metaDesc) metaDesc.setAttribute('content', prevDesc);
      if (metaOgTitle) metaOgTitle.setAttribute('content', prevTitle);
      if (metaOgDesc) metaOgDesc.setAttribute('content', prevDesc);
      if (metaTwitterTitle) metaTwitterTitle.setAttribute('content', prevTitle);
      if (metaTwitterDesc) metaTwitterDesc.setAttribute('content', prevDesc);
    };
  }, [title, description]);
}
